import Papa from 'papaparse';

export const calculateEstimatedTime = (file) => {
    return new Promise((resolve) => {
        Papa.parse(file, {
            complete: (results) => {
                // Subtract 1 to account for header row
                const numberOfUrls = Math.max(0, results.data.length - 1);
                // Calculate estimated minutes (100 URLs = 3 minutes)
                const estimatedMinutes = (numberOfUrls * 3) / 100;
                resolve(estimatedMinutes);
            },
            header: true,
            skipEmptyLines: true
        });
    });
};

export const formatTime = (minutes) => {
    if (minutes < 1) {
        const seconds = Math.round(minutes * 60);
        return `${seconds} second${seconds !== 1 ? 's' : ''}`;
    } else {
        const roundedMinutes = Math.round(minutes);
        return `${roundedMinutes} minute${roundedMinutes !== 1 ? 's' : ''}`;
    }
};